import { Injector } from "@angular/core";

export const AppConstants = {
  urls: {
    app: {
      login: "login",
    },
    api: {
      // /*Live*/
      base: "https://utp.edu-man.com/ut/api/",
      //base: "http://demo.kcompute.com:9014/ut/api/",
      reportNGUrl: "https://reportsp.edu-man.com/#/",
      reportUrl: "https://portalp.edu-man.com/WebForms/DevExReportViewer.aspx",
      externalURL: "https://vc.edu-man.com/",


      /*Local*/
      // base: "http://192.168.1.117:4323/ut/api/",
      // // base: "http://80.95.222.66:4321/ut/api",
      // reportNGUrl: "http://localhost:4200/#/",
      // reportUrl: "http://localhost:6005/WebForms/DevExReportViewer.aspx",
      // externalURL: "http://localhost:4200/",

      application: "",
    },
  },
  settings: { 
    version: "2.0.0.12",
    appCode: "SB",
    instanceid: 23,
    instancecode: "SM022",
    dateFormat: "dd-MMM-yyyy",
    timeFormat: "HH:mm:ss",
    dateFormatforString: "DD-MMM-YYYY",
    monthDateYear: "MM/DD/YYYY",
    timeFormatforString: "hh:mm:ss A",
    timeFormatTile: "hh:mm A",
    dateAndTime: "YYYY-MM-DDTHH:mm",
    date: "MMM d, y",
    clientid: 160,
  },
  policy: {
    dateFormat: "",
    timeFormat: "",
    gridpagging: false,
    defaultcityid: 0,
    defaultctryid: 0,
    defaultstateid: 0,
  },
  injector: <Injector>{},
};



// WEBPACK FOOTER //
// ./src/app/app.constant.ts